import { stringToSelectItem } from 'vet-bones/utils/select';

import { ReduxState } from 'src/store/types';

export const virtualGraphItemsSelector =
  (databaseId?: string) => (state: ReduxState) =>
    Object.values(state.dataSources.virtualGraphsById)
      .sort()
      .filter(
        ({ database }) =>
          !databaseId || database === '*' || database === databaseId
      )
      .map(({ name }) => stringToSelectItem(name));
